module.exports = __webpack_public_path__ + "static/img/php.23c6f7d2.png";